/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
// Pages
import Login from './Pages/Login';
import Home from './Pages/Home';
import ProductView from './Pages/ProductView';
import ProductEdit from './Pages/ProductEdit';
import ProductAdd from './Pages/ProductAdd';
import TypesPage from './Pages/TypesPage';
import Users from './Pages/Users';
import Navbar from './Components/Navbar';
import CustomRoute from './Components/CustomRoute';
import { autoLogin } from './functions/autoLogin';
import { Switch, Route, useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { loginByIdAction } from './Redux/actions/userAction';
import PrintCustom from './Pages/PrintCustom';
import History from './Pages/History';
import LocationPage from './Pages/LocationPage';
function App() {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { loggedIn } = useSelector((state) => state.user);
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [showAdminMenu, setShowAdminMenu] = useState(false);
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  // Better mobile detection using media query
  useEffect(() => {
    const checkIfMobile = () => {
      // Check both user agent and screen width
      const userAgent = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      const screenWidth = window.innerWidth <= 768; // Common mobile breakpoint
      setIsMobileDevice(userAgent || screenWidth);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const loginOrRedirect = async () => {
    try {
      await autoLogin(dispatch, loginByIdAction);
      if (!loggedIn && location.pathname !== '/') {
        setRedirectUrl('/');
        localStorage.setItem('preLoginUrl', location.pathname);
      } else if (loggedIn) {
        const preLoginUrl = localStorage.getItem('preLoginUrl');
        if (preLoginUrl) {
          setRedirectUrl(preLoginUrl);
          localStorage.removeItem('preLoginUrl');
        }
      }
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  useEffect(() => {
    loginOrRedirect();

    // Set showAdminMenu based on device type
    if (loggedIn) {
      setShowAdminMenu(!isMobileDevice); // False if mobile, true if web
    } else {
      setShowAdminMenu(false);
    }
  }, [location, loggedIn, isMobileDevice]); // Add isMobileDevice to dependencies

  useEffect(() => {
    if (redirectUrl) {
      history.push(redirectUrl);
      setRedirectUrl(null);
    }
  }, [redirectUrl]);

  return (
    <div className="App">
      <Navbar showAdminMenu={showAdminMenu} setShowAdminMenu={setShowAdminMenu} />
      <Switch>
        <Route path="/" exact render={() => <Login />} />
        <Route path="/home" exact render={() => <Home />} />
        <CustomRoute path="/product_view/" render={() => <ProductView />} />
        <CustomRoute path="/location" render={() => <LocationPage />} />
        <CustomRoute path="/product_edit/" render={() => <ProductEdit />} />
        <CustomRoute path="/product_add" render={() => <ProductAdd />} />
        <CustomRoute path="/history" render={() => <History />} />
        <CustomRoute path="/all_types" render={() => <TypesPage />} />
        <CustomRoute path="/print_custom" render={() => <PrintCustom />} />
        <CustomRoute path="/all_users" render={() => <Users />} />
      </Switch>
    </div>
  );
}
export default App;
